module.exports = __webpack_public_path__ + "static/media/9.Whistle start.7bf1fc36.wav";